import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';

import { fetchRollingArrangements } from 'actions/rollingArrangements';
import { getRollingArrangements, getPageCount } from 'reducers';

const withRollingArrangements = (DecoratedComponent) => {
  class WithRollingArrangements extends Component {
    state = {
      loading: false,
    };

    componentDidMount() {
      this.fetchRollingArrangements();
    }

    componentDidUpdate(prevProps, prevState) {
      const { page, user_profile, arrangement_day, enabled } = this.props;

      if (
        prevProps.page !== page ||
        prevProps.user_profile !== user_profile ||
        prevProps.arrangement_day !== arrangement_day ||
        prevProps.enabled !== enabled
      ) {
        this.fetchRollingArrangements();
      }
    }

    fetchRollingArrangements = () => {
      const {
        fetchRollingArrangements,
        page,
        user_profile,
        arrangement_day,
        enabled,
      } = this.props;
      const filters = {
        user_profile: user_profile || undefined,
        arrangement_day: arrangement_day || undefined,
        enabled: enabled || undefined,
      };
      this.setState({ loading: true });
      fetchRollingArrangements(filters, page).finally(() => {
        this.setState({ loading: false });
      });
    };

    render() {
      const { children, ...props } = this.props;
      const { loading } = this.state;
      const childrenProps = { ...props, loading };
      return React.createElement(DecoratedComponent, childrenProps, children);
    }
  }

  const mapStateToProps = (state, { location: { search } }) => {
    const {
      user_profile,
      arrangement_day,
      enabled,
      page = 1,
    } = qs.parse(search, { ignoreQueryPrefix: true });
    const rollingArrangements = getRollingArrangements(state, page);

    return {
      rollingArrangements,
      pageCount: getPageCount(
        state,
        'rollingArrangements',
        `rollingArrangements`,
        page,
      ),
      user_profile,
      arrangement_day,
      enabled,
      page,
    };
  };

  const mapDispatchToProps = {
    fetchRollingArrangements,
  };

  return connect(mapStateToProps, mapDispatchToProps)(WithRollingArrangements);
};

export default withRollingArrangements;
